var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-component"},[_c('h1',{staticClass:"title text-uppercase font-weight-black"},[_vm._v(_vm._s(_vm.object.name))]),_c('p',[_vm._v(" "+_vm._s(_vm.object.summary)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }